// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"168":"1ef9f326","986":"0b53b6ca"}[chunkId] + ".js";
};